import React from "react";
import FieldString from "../../string/string";
import FieldPhone_ManagementPreview from "./render/management-preview";
import {GROUP_INFO} from "../../../../gd/const/fields/field2-groups";
import FieldConfig from "../../../proto/field-config";
import FieldPhone_Editable from "./render/editable/editable";

export default class FieldPhone extends FieldString {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Phone";
        this.typeGroup          = GROUP_INFO
        this.typeDescription    = "Phone input field"
        this.icon               = 'i5-phone';

        this.components.ValueIcon = <span className={Classes("ui5-ico-16 m-r-10 fl-no-shrink", 'i5-phone')}/>

        this.renderComponents.managementPreview = FieldPhone_ManagementPreview
        this.renderComponents.editable          = FieldPhone_Editable
    }
}
